import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const Nav = styled.nav`
  background-color: ${theme.colors.primary};
  padding: ${theme.spacing.medium};
  margin-bottom: ${theme.spacing.large};
`;

const NavContainer = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled(Link)`
  text-decoration: none;
  
  img {
    height: 100px;
    width: auto;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.medium};
`;

const NavLink = styled(Link)`
  color: ${theme.colors.navText};
  text-decoration: none;
  font-weight: bold;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Navigation: React.FC = () => {
    return (
        <Nav>
            <NavContainer>
                <Logo to="/">
                    <img src="/icon_cropped.png" alt="Ufi IPTV" />
                </Logo>
                <NavLinks>
                    <NavLink to="/disclaimer">Disclaimer</NavLink>
                    <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                </NavLinks>
            </NavContainer>
        </Nav>
    );
};

export default Navigation;